const general = require('./general');
const officedepot = require('./officedepot');

const getData = (property) => {
  return (dataName) => {
    let target;
    switch(dataName) {
      case 'officedepot':
        target = officedepot;
        break;
      default:
        target = general;
    }
    return target[property];
  }
};

module.exports = {
  getAQL: getData('AQL_LEVELS'),
  getDefectCodes: getData('DEFECT_CODES'),

  bimbaylola: require('./bimbaylola'),
  brand: require('./brand'),
  general: require('./general'),
  haber: require('./haber'),
  officedepot: officedepot,
  petek: require('./petek'),
  riverisland: require('./riverisland'),
  soft: require('./soft'),
  superdry: require('./superdry'),
};
